import React from 'react';
import cuid from 'cuid';
import ValidationError from './ValidationError';
import Note from './Note';

const RadioButton = ({
  input,
  label,
  helper,
  meta: {error, touched} = {},
  disabled,
  id = cuid(),
  showError = true,
  ...rest
}) => (
  <>
    <label
      className={`inline-block ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      htmlFor={id}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <input
            id={id}
            {...input}
            {...rest}
            className={`h-5 ${disabled ? 'pointer-events-none' : ''}`}
            type="radio"
            disabled={disabled}
          />
        </div>

        <div className="ml-2">{label}</div>
      </div>
    </label>

    {helper && <Note value={helper} />}
    {error && touched && showError && <ValidationError value={error} />}
  </>
);

export default RadioButton;
